module.exports = __webpack_public_path__ + "img/NEO-alt.ff7a02ee.svg";